import { render, staticRenderFns } from "./RoleSet.vue?vue&type=template&id=3350353c"
import script from "./RoleSet.vue?vue&type=script&lang=js"
export * from "./RoleSet.vue?vue&type=script&lang=js"
import style0 from "./RoleSet.vue?vue&type=style&index=0&id=3350353c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports